import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { useAccessToken } from '../auth/AccessTokenContext';
import { getApiV1AnalogueModelsById } from '../api/generated';
import { queryKeys } from './queryKeys';

const ONE_MINUTE = 60_000;

export const useFetchModel = (id?: string) => {
  const { modelId } = useParams();
  const token = useAccessToken();

  const ID = id ? id : (modelId as string);
  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: queryKeys.analogueModel(ID),
    queryFn: () =>
      getApiV1AnalogueModelsById({
        path: { id: ID },
        query: {
          expand:
            'outcrops, stratigraphicgroups, fileuploads, modelareas, geologicalgroups, inifile, computecases',
        },
      }),
    select: (res) => res.data?.data,
    enabled: !!token && !!ID,
    refetchInterval: (query) =>
      query.state.data?.data?.data?.isProcessed === false ? ONE_MINUTE : false,
  });

  return query;
};
